<template>
  <select-dict
    v-model="deliverySelectType"
    :selectList="deliveryList"
    :select-first-item="true"
    :disabled="disableSelect"
  />
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import SelectDict from "@/components/UI/SelectDict.vue";
import {
  DeliveryNonSelectedType,
  DeliveryCombinedType,
  DeliveryDirectType,
  minWeightForDirectDelivery,
} from "@/app/constants";

import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useDeliveryStore } from "@/stores/new/delivery.store";

const estimateStore = useNewEstimateStore();
const deliveryStore = useDeliveryStore();

const emit = defineEmits(["update:showText"]);
const deliverySelectType = defineModel<string>();
const deliveryList = ref<any>([]);
const disableSelect = ref<any>([]);

// set delivery list options and default value
watch(
  () => [deliveryStore.deliveryType, deliveryStore.totalWeight],
  ([currentDeliveryType, weight]) => {
    if (
      currentDeliveryType === DeliveryDirectType &&
      weight &&
      +weight > minWeightForDirectDelivery
    ) {
      deliverySelectType.value = currentDeliveryType;
      disableSelect.value = true;

      deliveryList.value = [
        { id: "1", code: DeliveryDirectType, title: "Direct" },
      ];
      return;
    }

    if (
      currentDeliveryType === DeliveryCombinedType ||
      currentDeliveryType === DeliveryDirectType
    ) {
      deliverySelectType.value = currentDeliveryType;
      disableSelect.value = false;

      deliveryList.value = [
        { id: "1", code: DeliveryCombinedType, title: "Combined" },
        { id: "2", code: DeliveryDirectType, title: "Direct" },
      ];
      return;
    }

    emit("update:showText", true);
    disableSelect.value = true;
    deliverySelectType.value = DeliveryNonSelectedType;
    deliveryList.value = [
      { id: "1", code: DeliveryNonSelectedType, title: "Not selected" },
    ];
  },
  { deep: true },
);

// update estimate delivery type based on delivery type in store
watch(
  () => [deliveryStore.deliveryType, estimateStore.estimate.delivery],
  ([currentDeliveryType, isDelivery]) => {
    if (isDelivery) {
      estimateStore.estimate.deliveryType = currentDeliveryType;
    } else {
      estimateStore.estimate.deliveryType = "";
    }
  },
  { deep: true },
);

// update delivery type in store when selection changes
watch(
  () => deliverySelectType.value,
  (value) => {
    if (value === DeliveryNonSelectedType) {
      deliveryStore.deliveryType = "";
    } else {
      deliveryStore.deliveryType = value;
    }
  },
  { deep: true },
);
</script>

<style lang="scss" scoped></style>
